export default (t) => [
    {
        route: 'settings.certificate.create',
        label: t('navigation.settings_certificates'),
        showInSidebar: true,
        permissions: ['settings.certificate']
    },
    {
        route: 'settings.certificate.store',
        label: t('navigation.settings_certificates'),
        showInSidebar: false
    },
    {
        route: 'settings.certificate-providers.index',
        label: t('navigation.settings_certificate_providers'),
        showInSidebar: true
    },
    {
        route: 'settings.certificate-providers.create',
        label: t('navigation.settings_certificate_providers_create'),
        showInSidebar: false
    },
    {
        route: 'settings.certificate-providers.edit',
        label: t('navigation.settings_certificate_providers_edit'),
        showInSidebar: false
    },
    {
        route: 'settings.certificate-providers.store',
        label: t('navigation.settings_certificate_providers_store'),
        showInSidebar: false
    },
    {
        route: 'settings.allowed-ips.index',
        label: t('navigation.settings_allowed_ips'),
        showInSidebar: true,
        permissions: ['settings.allowed_ips']
    },
    {
        route: 'settings.one-hop.create',
        label: t('navigation.settings_dns_providers'),
        showInSidebar: true,
        permissions: ['settings.one-hop']
    },
    {
        route: 'settings.one-hop.store',
        label: t('navigation.settings_dns_providers'),
        showInSidebar: false
    },
    {
        route: 'settings.one-crm.create',
        label: t('navigation.settings_onecrm'),
        showInSidebar: true,
        permissions: ['settings.one-crm']
    },
    {
        route: 'settings.one-crm.store',
        label: t('navigation.settings_onecrm'),
        showInSidebar: false
    },
    {
        route: 'settings.hosting-platforms.index',
        label: t('navigation.settings_hosting_platforms'),
        showInSidebar: true,
        permissions: ['settings.hosting-platforms']
    },
    {
        route: 'settings.hosting-platforms.create',
        label: t('navigation.settings_hosting_platforms_create'),
        showInSidebar: false
    },
    {
        route: 'settings.hosting-platforms.edit',
        label: t('navigation.settings_hosting_platforms_edit'),
        showInSidebar: false
    },
    {
        route: 'settings.logo.edit',
        label: t('navigation.settings_logo'),
        showInSidebar: true,
        permissions: ['settings.logo']
    }
]
